import { assert, CheckedAddress } from '@sparkdotfi/common-universal'

import { getChainConfigEntry } from '@/config/chain'
import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { useTokenRepository } from '@/domain/token-repository/useTokenRepository'

export interface UseSpkTokenRepositoryParams {
  chainId: number
  account: CheckedAddress | undefined
}

export function useSpkTokenRepository({ chainId, account }: UseSpkTokenRepositoryParams): TokenRepository {
  const chainConfig = getChainConfigEntry(chainId)
  const spkConfig = chainConfig.spk
  assert(spkConfig, 'SPK config not available for this chain')

  return useTokenRepository({
    chainId,
    priceConfigs: spkConfig.priceConfigs,
    account,
  })
}
